import { StatusDot } from 'components/StatusIndicator/IgnitionStatusIndicator';
import { isAssetIgnition } from 'views/FleetOverview/helpers/asset.helpers';

interface Props {
  value: string;
  data: any;
  handleVehicleClick: (
    bumper_id: string,
    start_ts: string,
    dtc_type_2: string
  ) => void;
  handleDTCCodeClick: (dtcCode: string) => void;
  latestTagData: any;
  asset: any;
}

export const VehicleDisplay = ({
  data: {
    asset: assetString,
    bumper_id: bumperId,
    start_ts: startTs,
    dtc_type_2: dtcType,
  },
  handleVehicleClick,
  latestTagData,
  asset,
}: Props) => {
  return (
    <>
      <StatusDot isActive={isAssetIgnition(latestTagData, asset)} />
      <span>{assetString}</span>
    </>
  );
};

export const DTCCodeDisplay = ({ data: { dtc_code: dtcCode } }: Props) => {
  const displayValue =
    dtcCode === 'ParameterNotAvailable' ? 'Reason Unknown' : dtcCode;

  return <span>{displayValue}</span>;
};
